import React from 'react';
import styled from 'styled-components';

/**
 * Wrapper 컴포넌트 Props
 * @typedef {Object} WrapperProps
 * @property {React.ReactNode} [title] - 제목
 * @property {React.ReactNode} children - 콘텐츠
 * @property {React.ReactNode} [actionButtons] - 액션 버튼들
 * @property {React.ReactNode} [trailAction] - 후행 액션
 */

const Wrapper = ({ title, children, actionButtons, trailAction }) => {
  return (
    <>
      <Container>
        {actionButtons && <ActionButtons>{actionButtons}</ActionButtons>}
        {title}
        {children}
      </Container>
      {trailAction && <TrailAction>{trailAction}</TrailAction>}
    </>
  );
};

const Container = styled.div`
  width: 100%;
`;

const ActionButtons = styled.div`
  margin-bottom: 10px;
`;

const TrailAction = styled.div`
  margin-top: 10px;
`;

export default Wrapper;
